const bodyParts = {
    頭: ["頭痛", "めまい", "熱"],
    胸: ["息苦しさ", "胸痛"],
    腹: ["腹痛", "吐き気"],
    手足: ["しびれ", "痛み"],
    メンタル: ["ストレス", "不安", "気分の落ち込み", "睡眠不足", "集中力低下"],
  };
  
  export default bodyParts;
  